export default function isBoxWithSizes(box) {
  return box.variants && box.variants.length > 1;
}